import { type FC } from 'react'
import { SelectDropdown, type SelectOption } from '../SelectDropdown/SelectDropdown'
import type { CustomWorkflowLauncher } from './useCustomWorkflowLauncher'
import { workflowMenuLabel } from './workflowMenuLabel'

const DEFAULT_DROPDOWN_CLASS = 'zocks-py-0.375 zocks-px-0.75'

export interface WorkflowsMenuProps {
  launcher: CustomWorkflowLauncher
  dropdownClassName?: string
}

export const WorkflowsMenu: FC<WorkflowsMenuProps> = ({ launcher, dropdownClassName = DEFAULT_DROPDOWN_CLASS }) => {
  if (!launcher.enabled || (!launcher.isLoading && launcher.workflows.length === 0)) {
    return null
  }

  const options: SelectOption[] = launcher.workflows.map((workflow) => ({ id: workflow.id, label: workflowMenuLabel(workflow) }))
  const onOptionSelected = (option: SelectOption) => launcher.launch(option.id)

  return (
    <>
      <div className='header-dropdown-container d-none d-xl-block position-relative'>
        <SelectDropdown
          label='Agents'
          icon='bi-stars'
          options={options}
          onOptionSelected={onOptionSelected}
          loading={launcher.isLoading}
          className={dropdownClassName}
        />
      </div>
      <div className='header-dropdown-container d-none d-sm-block d-xl-none'>
        <SelectDropdown
          icon='bi-stars'
          iconOnly
          ariaLabel='Agents'
          options={options}
          onOptionSelected={onOptionSelected}
          loading={launcher.isLoading}
          className={dropdownClassName}
        />
      </div>
      {launcher.runModal}
    </>
  )
}
